// SCH-03: extended from PS..CE2 (6 values, FND-02) to 12 values across three
// combinable cycles (Préscolaire/Élémentaire/Collège — Lycée excluded from this
// version). See `cycle.ts` for the level -> cycle mapping.
// SCH-13: CI (Cours d'Initiation) added — the actual FIRST level of the Senegalese
// elementary cycle, before CP, missing since SCH-03 (product mistake, not a new
// level). Positioned here before CP to match the real backend enum order
// (apps/api/prisma/schema.prisma, ALTER TYPE ... ADD VALUE 'CI' BEFORE 'CP').
export const CLASS_LEVELS = [
  'PS',
  'MS',
  'GS',
  'CI',
  'CP',
  'CE1',
  'CE2',
  'CM1',
  'CM2',
  'SIXIEME',
  'CINQUIEME',
  'QUATRIEME',
  'TROISIEME',
] as const;
export type ClassLevel = (typeof CLASS_LEVELS)[number];

export function isClassLevel(value: string): value is ClassLevel {
  return (CLASS_LEVELS as readonly string[]).includes(value);
}

/** French display labels ("6ème" rather than "SIXIEME") — cosmetic only, never
 * sent to/received from the backend, which keeps using the raw enum values. */
export const CLASS_LEVEL_LABELS: Record<ClassLevel, string> = {
  PS: 'Petite Section',
  MS: 'Moyenne Section',
  GS: 'Grande Section',
  CI: 'CI',
  CP: 'CP',
  CE1: 'CE1',
  CE2: 'CE2',
  CM1: 'CM1',
  CM2: 'CM2',
  SIXIEME: '6ème',
  CINQUIEME: '5ème',
  QUATRIEME: '4ème',
  TROISIEME: '3ème',
};

/** A class (level + school year) within a school. `name` is always auto-generated
 * (LEVEL-SUFFIX, e.g. CE1-A) — never editable by a client, see apps/api/src/lib/
 * classNaming.ts. `capacity: null` means "not set", not zero. */
export interface SchoolClass {
  id: string;
  tenantId: string;
  level: ClassLevel;
  name: string;
  schoolYear: string;
  capacity: number | null;
  createdAt: string;
  updatedAt: string;
}
